import * as z from 'zod'

import {BackgroundImageSchema} from './backgroundImage'
import {PrimerComponentCtaBannerSchema} from './primerComponentCtaBanner'
import {PrimerComponentFaqGroupSchema} from './primerComponentFaqGroup'
import {PrimerComponentHeroSchema} from './primerComponentHero'
import {PrimerComponentSubnavSchema} from './primerComponentSubnav'
import {PrimerComponentSectionIntroSchema} from './primerComponentSectionIntro'
import {PrimerCardsSchema} from './primerCards'
import {FlexSectionSchema} from './flexSection'
import {buildEntrySchemaFor} from '../entry'
import {buildPageSchemaForTemplate} from './containerPage'
import {PrimerComponentBreadcrumbSchema} from './primerComponentBreadcrumb'
import {PrimerComponentStaticFootnotesSchema} from './primerComponentStaticFootnotes'
import {RenderingStrategySchema} from './renderingStrategy'
import {safeOptional} from '../../safe-optional'

export const FlexTemplateVisualSettingsSchema = buildEntrySchemaFor('flexTemplateVisualSettings', {
  fields: z.lazy(() =>
    z.object({
      heroPaddingBlockEnd: z.enum(['none', 'condensed', 'spacious']).optional(),
      subNavOverlapsHeroBackgroundImage: z.boolean().optional(),
      trailingSectionRoundedCorners: z.boolean().optional(),
      trailingSectionBackgroundColor: z.enum(['default', 'subtle']).optional(),
    }),
  ),
})

export const TemplateFlexSchema = buildEntrySchemaFor('templateFlex', {
  fields: z.lazy(() =>
    z.object({
      subnav: safeOptional(PrimerComponentSubnavSchema),
      breadcrumbs: safeOptional(z.array(PrimerComponentBreadcrumbSchema)),
      hero: PrimerComponentHeroSchema,
      heroStrategies: safeOptional(z.array(RenderingStrategySchema)),
      heroBackgroundImage: safeOptional(BackgroundImageSchema),
      sections: z.array(FlexSectionSchema),
      ctaBanner: safeOptional(PrimerComponentCtaBannerSchema),
      sectionIntro: safeOptional(PrimerComponentSectionIntroSchema),
      cards: safeOptional(PrimerCardsSchema),
      faq: safeOptional(PrimerComponentFaqGroupSchema),
      staticFootnotes: safeOptional(PrimerComponentStaticFootnotesSchema),
      visualSettings: safeOptional(FlexTemplateVisualSettingsSchema),
    }),
  ),
})

export const FlexPageSchema = buildPageSchemaForTemplate(TemplateFlexSchema)
export type FlexPage = z.infer<typeof FlexPageSchema>
